import React from 'react';
import MerchantDashboard from './MerchantDashboard/MerchantDashboard';
import DashboardAdmin from './DashboardAdmin';
import DashboardManager from './DashboardManager';
import DashboardStaff from './DashboardStaff';

type Role = 'admin' | 'merchant' | 'merchant_manager' | 'merchant_staff' | 'manager' | 'staff';

interface DashboardProps {
    role: Role;
}

const ROLE_MAP: Partial<Record<Role, Role>> = {
    merchant_manager: 'manager',
    merchant_staff: 'staff',
};

const Dashboard: React.FC<DashboardProps> = ({ role }) => {
    const normalizedRole = ROLE_MAP[role] || role;

    return (
        <div>
            {normalizedRole === 'admin' && <DashboardAdmin />}
            {normalizedRole === 'merchant' && <MerchantDashboard />}
            {normalizedRole === 'staff' && <DashboardStaff />}
            {normalizedRole === 'manager' && <DashboardManager />}
        </div>
    );
};

export default Dashboard;
